import React, { useState, useEffect } from 'react';
import { Route, Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/SideBar';
import Bookings from '../Booking/Bookings';
import Navbar from '../Navbar/Navbar';
import Dashboard from '../Dashboard/Dashboard';
import ViewSMSLog from '../SMS/SMSViewLog';
// import EntroKeypad from '../Keybad/EntroKeypad';
import Connection from '../Connection/Connection';
import Device from '../Device/Device';
import Events from '../Events/Events';
import Actions from '../Actions/Actions';
import Users from '../Users/Users';
import Help from '../Help/Help';
import Profile from '../Profile/Profile';
import Companies from '../Companies/Companies';
import { useSingleSession } from '../Auth/useSingleSession';
import MetricsVisualizer from '../Monitoring/MetricsVisualizer';

const SystemAdmin = () => {
  useSingleSession();
  const history = useHistory();
  const location = useLocation();
  const isAuthenticated = localStorage.getItem('userId');
  const userData = location.state?.userData;
  const storedRole = localStorage.getItem('role');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [activeTab, setActiveTab] = useState(sessionStorage.getItem('activeSidebarTab') || 'Dashboard');

  const handleTabChangeSide = (tab, path) => {
    setActiveTab(tab); // Update the active tab state
    sessionStorage.setItem('activeSidebarTab', tab); // Persist the active tab in session storage
    if (path) {
      history.push(path); // Navigate to the specified path
    }
  };

  // Store current path on page change
  useEffect(() => {
    sessionStorage.setItem('lastPath', location.pathname);
  }, [location]);

  // Ensure proper navigation to last visited path on refresh
  useEffect(() => {
    if (!isAuthenticated) {
      history.push('/login');
    } else {
      const lastPath = sessionStorage.getItem('lastPath') || '/admin/dashboard';
      history.replace(lastPath);
    }
  }, [isAuthenticated, history]);

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return (
    <div className="flex">
      <div className="hidden md:block">
        <Sidebar handleTabChangeSide={handleTabChangeSide} activeTab={activeTab} />
      </div>

      {/* Main content section */}
      <div className="flex-1 bg-gray-100 flex flex-col">
        <div className="block lg:hidden md:hidden">
          <Navbar userData={userData} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        </div>

        <Switch>
          <Route path="/admin/dashboard" exact>
            <Dashboard userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/booking">
            <Bookings userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide}  />
          </Route>
          <Route path="/admin/sms">
            <ViewSMSLog userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          {/* <Route path="/admin/keypad">
            <EntroKeypad userData={userData} setIsMenuOpen={setIsMenuOpen} />
          </Route> */}
          <Route path="/admin/connections">
            <Connection userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/devices">
            <Device userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/events">
            <Events userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/actions">
            <Actions userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/users">
            <Users userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/help">
            <Help userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/profile">
            <Profile userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/companies">
            <Companies userData={userData} setIsMenuOpen={setIsMenuOpen} handleTabChangeSide ={handleTabChangeSide} />
          </Route>
          <Route path="/admin/monitors">
            <MetricsVisualizer userData={userData} setIsMenuOpen={setIsMenuOpen} />
          </Route>
          <Route path="/admin/profile">
                <Profile userData={userData} setIsMenuOpen={setIsMenuOpen} />
            </Route>

          <Redirect exact from="/admin" to="/admin/dashboard" />
        </Switch>
      </div>
    </div>
  );
};

export default SystemAdmin;